import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'gen',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/index.vue'),
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/product.vue'),
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/productDetail.vue'),
  },
  {
    path: '/packaging',
    name: 'Packaging',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/packaging.vue'),
  },
  {
    path: '/vehicle',
    name: 'Vehicle',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/vehicle.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/about.vue'),
  },
  {
    path: '/connection',
    name: 'Connection',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/connection.vue'),
  },
]

const router = new VueRouter({
  routes
  // mode: 'history',
})

router.beforeEach((to, from, next) => {
  if(to.name=='Index'){
      next()
  }else{
    next()
  }
})

export default router